import { DETAIL_PROSES, MENU_PROSES } from "./prosesPendaftaranTypes";

const initialState = {
    menuProses: [],
    detailProses: []
}

const prosesPendaftaranReducers = (state = initialState, action) => {
    switch (action.type) {
        case MENU_PROSES:
            return {
                ...state,
                menuProses: action?.payload?.value,
            };
        case DETAIL_PROSES:
            return {
                ...state,
                detailProses: action?.payload?.value,
            };
        default:
            return state;
    }
}

export default prosesPendaftaranReducers;